import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PersonPlusIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="personPlus" ref={ref} {...props}>
      <path d="M14,11.9a4.58,4.58,0,1,1,4.57-4.58A4.58,4.58,0,0,1,14,11.9Zm0-7.65A3.08,3.08,0,1,0,17,7.32,3.08,3.08,0,0,0,14,4.25ZM22.75,20.5A5.71,5.71,0,0,0,17,14.79H10.78A5.71,5.71,0,0,0,5.07,20.5a.75.75,0,0,0,1.5,0,4.22,4.22,0,0,1,4.21-4.21H17a4.22,4.22,0,0,1,4.21,4.21.75.75,0,0,0,1.5,0ZM7.83,11.57H5.77V9.5a.75.75,0,0,0-1.5,0v2.07H2.2a.75.75,0,0,0,0,1.5H4.27v2.06a.75.75,0,0,0,1.5,0V13.07H7.83a.75.75,0,0,0,0-1.5Z" />
    </Icon>
  ),
) as IconWithRender;

PersonPlusIcon.displayName = 'PersonPlusIcon';
PersonPlusIcon.renderIcon = (props) => <PersonPlusIcon {...props} />;
export default PersonPlusIcon;
